import { gql } from "@apollo/client";

export const salesOrderState = {
  salesOrderId: "",
  customerName: "",
  customerAddress: "",

  soType: "",
  orderDate: "",
  productDetails: [
    {
      itemName: "",
      qty: "",
      priceCode: "",
      uomType: "",
      productPrice: "",
      taxPercentage: "",
      taxAmount: "",
      amount: "",
      totalAmountProduct: "",
      uomTypeOption: [],
      originalproductPrice: "",
      calucualtedPrice: "",
      conversation: "",

      itemNameStatus: "unchecked",
      qtyStatus: "unchecked",
      priceCodeStatus: "unchecked",
      uomTypeStatus: "unchecked",
      productPriceStatus: "unchecked",
      taxPercentageStatus: "unchecked",
      taxAmountStatus: "unchecked",
      amountStatus: "unchecked",
      calucualtedPriceStatus: "unchecked",
    },
  ],
  terms: "",
  discount: "",
  totalAmount: "",
  grandTotal: "",

  salesOrderIdStatus: "unchecked",
  customerNameStatus: "unchecked",
  soTypeStatus: "unchecked",
  orderDateStatus: "unchecked",
  termsstatus: "unchecked",
  discountStatus: "unchecked",
  totalAmountStatus: "unchecked",
  grandTotalStatus: "unchecked",
  customerAddressStatus: "unchecked",
  selectPriceCode: "",
};

export const salesOrderStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;
  const index = action.index;
  const type = action.type;
  const allPricecode = action?.allPricecode;
  const newIndex = action?.newIndex;

  if (type === "add") {
    return {
      ...state,
      productDetails: [
        ...state.productDetails,
        {
          itemName: "",
          qty: "",
          priceCode: state?.selectPriceCode,
          uomType: "",
          productPrice: "",
          taxPercentage: "",
          taxAmount: "",
          amount: "",
          totalAmountProduct: "",
          uomTypeOption: [],
          originalproductPrice: "",
          calucualtedPrice: "",
          conversation: "",

          itemNameStatus: "unchecked",
          qtyStatus: "unchecked",
          priceCodeStatus: "success",
          uomTypeStatus: "unchecked",
          productPriceStatus: "unchecked",
          taxPercentageStatus: "unchecked",
          taxAmountStatus: "unchecked",
          amountStatus: "unchecked",
          calucualtedPriceStatus: "unchecked",
        },
      ],
    };
  } else if (type === "delete") {
    const newProductDetails = state.productDetails.filter(
      (_, i) => i !== index
    );
    return {
      ...state,
      productDetails: newProductDetails,
    };
  } else if (type == "uomtypearray") {
    const newfilterarray = state?.productDetails?.filter((val, ind) => {
      if (ind == newIndex) {
        return {
          ...val,
          uomTypeOption: value,
        };
      }
    });
    return {
      ...state,
      productDetails: newfilterarray,
    };
  } else if (typeof index === "number") {
    const updatedProductDetails = [...state.productDetails];
    const currentProduct = { ...updatedProductDetails[index] };

    if (inputName && value !== undefined) {
      currentProduct[inputName] = value;

      const statusKey = `${inputName}Status`;
      if (currentProduct.hasOwnProperty(statusKey)) {
        currentProduct[statusKey] = value ? "success" : "unchecked";
      }

      updatedProductDetails[index] = currentProduct;

      return {
        ...state,
        productDetails: updatedProductDetails,
      };
    }

    return state;
  } else if (allPricecode) {
    if (value) {
      const updatedProductDetails = state?.productDetails?.map((product) => ({
        ...product,
        priceCode: value,
        priceCodeStatus: "success",
      }));
      return {
        ...state,
        selectPriceCode: value,
        productDetails: updatedProductDetails,
      };
    }
  } else {
    switch (inputName) {
      case "salesOrderId": {
        const alphaNLenghthRegex = new RegExp("^.{1,100}$");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            salesOrderId: value,
            salesOrderIdStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            salesOrderId: "",
            salesOrderIdStatus: "unchecked",
          };
        } else {
          return {
            ...state,
            salesOrderId: value,
            salesOrderIdStatus: "error",
          };
        }
      }
      case "customerAddress": {
        if (value) {
          return {
            ...state,
            customerAddress: value,
            customerAddressStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            customerAddress: "",
            customerAddressStatus: "unchecked",
          };
        }
      }

      case "customerName": {
        if (value) {
          return {
            ...state,
            customerName: value,
            customerNameStatus: "success",
          };
        } else if (!value) {
          const updatedProductDetails = state?.productDetails?.map(
            (product) => ({
              ...product,

              itemName: "",
              qty: "",
              priceCode: "",
              uomType: "",
              productPrice: "",
              taxPercentage: "",
              taxAmount: "",
              amount: "",
              totalAmountProduct: "",
              uomTypeOption: [],
              originalproductPrice: "",
              calucualtedPrice: "",
              conversation: "",

              itemNameStatus: "unchecked",
              qtyStatus: "unchecked",
              priceCodeStatus: "unchecked",
              uomTypeStatus: "unchecked",
              productPriceStatus: "unchecked",
              taxPercentageStatus: "unchecked",
              taxAmountStatus: "unchecked",
              amountStatus: "unchecked",
              calucualtedPriceStatus: "unchecked",
            })
          );
          return {
            ...state,
            selectPriceCode: "",
            productDetails: updatedProductDetails,
            customerName: "",
            customerNameStatus: "unchecked",
            customerAddress: "",
            customerAddressStatus: "unchecked",
          };
        }
      }
      case "soType": {
        if (value) {
          return {
            ...state,
            soType: value,
            soTypeStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            soType: "",
            soTypeStatus: "unchecked",
          };
        }
      }
      case "orderDate": {
        const alphaNLenghthRegex = new RegExp("^.{1,100}$");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            orderDate: value,
            orderDateStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            orderDate: "",
            orderDateStatus: "unchecked",
          };
        } else {
          return {
            ...state,
            orderDate: value,
            orderDateStatus: "error",
          };
        }
      }
      case "terms": {
        const alphaNLenghthRegex = new RegExp("^.{1,10000}$", "s");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            terms: value,
            termsstatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            terms: "",
            termsstatus: "unchecked",
          };
        } else {
          return {
            ...state,
            terms: value,
            termsstatus: "error",
          };
        }
      }
      case "discount": {
        const alphaNLenghthRegex = new RegExp("^.{1,100}$");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            discount: value,
            discountStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            discount: "",
            discountStatus: "unchecked",
          };
        } else {
          return {
            ...state,
            discount: value,
            discountStatus: "error",
          };
        }
      }
      case "totalAmount": {
        const alphaNLenghthRegex = new RegExp("^.{1,100}$");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            totalAmount: value,
            totalAmountStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            totalAmount: "",
            totalAmountStatus: "unchecked",
          };
        } else {
          return {
            ...state,
            totalAmount: value,
            totalAmountStatus: "error",
          };
        }
      }
      case "grandTotal": {
        const alphaNLenghthRegex = new RegExp("^.{1,100}$");

        if (alphaNLenghthRegex.test(value)) {
          return {
            ...state,
            grandTotal: value,
            grandTotalStatus: "success",
          };
        } else if (!value) {
          return {
            ...state,
            grandTotal: "",
            grandTotalStatus: "unchecked",
          };
        } else {
          return {
            ...state,
            grandTotal: value,
            grandTotalStatus: "error",
          };
        }
      }
      case "allProduct": {
        return {
          ...state,
          productDetails: value,
        };
      }
      case "selectPriceCode": {
        return {
          ...state,
          selectPriceCode: { value: value, label: value },
        };
      }
      default:
        return state;
    }
  }
};

export const productCodeOption = ["BAS", "COD", "CSH", "SMT", "VANSL"];

export const getCustomer = gql`
  query GetCustomerById($id: ID!) {
    getCustomer(id: $id) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      customers {
        id
        customerName
        priceCode
      }
    }
  }
`;

export const todayDateProducts = gql`
  query {
    todayDateProducts {
      data {
        id
        productCode
        productName
      }
    }
  }
`;

export const todayDateProductsDropdown = gql`
  query {
    todayDateProductsDropdown {
      success
      message
      data {
        id
        productCode
        productName
        currentStock
        productBrand
      }
    }
  }
`;
export const getProductCode = gql`
  query getproductcode($productocde: String!) {
    getProductCode(productCode: $productocde) {
      data {
        productName
        bas
        cod
        csh
        smt
        vansl
        productUom
        baseUom
        conversion
        vat
      }
    }
  }
`;

export const soTypeOption = ["Telephone Order", "Visit Order"];

export const createSalesOrder = gql`
  mutation CreateSalesOrder($input: CreateSalesOrderInput!) {
    createSalesOrder(input: $input) {
      success
      message
      error
      data {
        id
        soNumber
        customer {
          id
          customerName
        }
        customerAddress
        orderType
        totalAmount
        grandTotal
        status
      }
    }
  }
`;

export const allsalesorders = gql`
  query GetAllSalesOrders {
    allsalesorders {
      success
      message
      data {
        id
        sio
        soNumber
        orderType
        orderDate
        discount
        totalAmount
        grandTotal
        status
        customer {
          customerName
        }
        user {
          id
          username
          employeeName
        }
        customerAddress
        termsAndConditions
        status
        createdAt
        lastupdate
        salesorderproductSet {
          id
          product {
            id
            productName
          }
          uomType
          quantity
          priceCode
          price
          tax
          taxAmount
          amount
          totalAmount
          createdAt
          lastupdate
        }
      }
    }
  }
`;

export const getCustomermasterByCode = gql`
  query GetCustomerMasterByCode($code: String!) {
    getCustomermasterByCode(code: $code) {
      success
      message
      error
      totalCount
      data {
        id
        customerCode
        customerName
        customerCategory
        status
        creditLimit
        creditPeriod
        addresses {
          id
          address
          latitude
          longitude
        }
      }
    }
  }
`;

export const unassignedSalesOrders = gql`
  query {
    unassignedSalesOrders {
      success
      message
      error
      data {
        orderSio
        customerName
        orderDate
        totalAmount
        status
        products {
          productName
          quantity
          price
          tax
          amount
        }
      }
    }
  }
`;

export const updateSalesOrder = gql`
  mutation updatesalesorder($input: UpdateSalesOrderInput!) {
    updateSalesOrder(input: $input) {
      success

      message

      error
    }
  }
`;

export const generateSalesorderPdf = gql`
  mutation generateSalesorderPdf($id: Int!) {
    generateSalesorderPdf(id: $id) {
      success
      message
      pdfUrl
    }
  }
`;

export const todayCustomersDropdown = gql`
  query TodayCustomersDropdown {
    todayCustomersDropdown {
      success
      message
      data {
        id
        customerName
        customerCode
      }
    }
  }
`;

export const getSalesorderById = gql`
  query GetSalesOrder($id: Int!) {
    getSalesorder(id: $id) {
      success
      message
      error
      data {
        id
        sio
        soNumber
        orderType
        orderDate
        discount
        totalAmount
        grandTotal
        status
        customer {
          id
          customerName
          customerCode
        }
        user {
          id
          username
        }
        termsAndConditions
        createdAt
        lastupdate
        salesorderproductSet {
          id
          product {
            id
            productName
          }
          uomType
          quantity
          priceCode
          price
          tax
          taxAmount
          amount
          totalAmount
          createdAt
          lastupdate
        }
      }
      selectedCustomerAddress {
        id
        address
        latitude
        longitude
      }
    }
  }
`;
